import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import org from "./modules/org";
import packages from "./modules/package";
import order from "./modules/order";
import family from "./modules/family";
import report from "./modules/report";
import user from "./modules/user";
import notice from "./modules/notice";
import goods from "./modules/goods";
import medical from "./modules/medical";
import rights from "./modules/rights";
import healthInsurance from "./modules/healthInsurance";
import coupon from "./modules/coupon";

const login = () => import("src/views/login.vue");
const verification = () => import("src/views/register/verification.vue");
const home = () => import("src/views/home.vue");
const category = () => import("src/views/category/index.vue");
const HealthProductHome = () => import("src/views/healthProduct/home.vue");
const HealthProductList = () => import("src/views/healthProduct/list.vue");
const HealthProductArticle = () => import("src/views/healthProduct/article.vue");
const HealthProductArticleDetail = () => import("src/views/healthProduct/article-detail.vue");
const Pay = () => import("src/views/pay.vue");
const loginPrivacy = () => import("src/views/user/privacy/login-privacy.vue");
const reportList = () => import("src/views/report/list.vue");
const rightsPrivacy = () => import("src/views/rights-privacy.vue");
const storeClose = () => import("src/views/storeClose.vue");

// 神策
import sensors from "../sensors";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/login",
    name: "login",
    component: login,
    meta: {
      title: "登录页",
      pageName: "GJ_登录页",
    },
  },
  {
    path: "/verification",
    name: "verification",
    component: verification,
    meta: {
      title: "输入验证码",
      pageName: "GJ_输入验证码",
    },
  },

  {
    path: "/home",
    name: "home",
    component: home,
    meta: {
      title: "首页",
      pageName: "GJ_店铺首页",
      keepAlive: true,
      tabbarName: "home",
    },
  },
  {
    path: "/category",
    name: "category",
    component: category,
    meta: {
      title: "分类",
      pageName: "GJ_分类页",
    },
  },
  {
    path: "/storeClose",
    name: "storeClose",
    component: storeClose,
    meta: {
      title: "我的健康小店",
      pageName: "GJ_店铺关闭",
    },
  },
  {
    path: "/health/product/home",
    name: "health-product-home",
    component: HealthProductHome,
    meta: {
      title: "健康",
      tabbarName: "health-product-home",
    },
  },
  {
    path: "/health/product/list",
    name: "health-product-list",
    component: HealthProductList,
    meta: {
      tabbarName: "大家都在用",
    },
  },
  {
    path: "/health/product/article",
    name: "health-product-article",
    component: HealthProductArticle,
    meta: {
      tabbarName: "健康文章列表",
    },
  },
  {
    path: "/health/product/article/detail",
    name: "health-product-article-detail",
    component: HealthProductArticleDetail,
    meta: {
      tabbarName: "健康文章详情",
    },
  },
  {
    path: "/login-privacy",
    name: "login-privacy",
    component: loginPrivacy,
    meta: {
      tabbarName: "登录协议列表",
      pageName: "GJ_登录协议",
    },
  },
  {
    path: "/pay",
    name: "pay",
    component: Pay,
    meta: {
      tabbarName: "选择支付方式",
      pageName: "GJ_支付页",
    },
  },
  ...org,
  ...packages,
  ...order,
  ...family,
  ...report,
  ...user,
  ...notice,
  ...goods,
  ...medical,
  ...healthInsurance,
  ...rights,
  ...coupon,
];

let urlArr = location.pathname.split("/");
let appid = urlArr[1] || "aia";

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL + `${appid}/`,
  routes,
});

router.beforeEach((to, from, next) => {
  let orgName = "";
  let orgInfoStorge = localStorage.getItem("orgInfo");
  // 注册公共属性
  sensors.registerPage({
    page_name: to.meta.pageName || "",
  });
  if (orgInfoStorge) {
    orgName = JSON.parse(orgInfoStorge).orgName;
  }
  if (to.meta.title || orgName) {
    document.title = to.meta.title || orgName;
  }

  let urlArr = location.pathname.split("/");
  let appid = urlArr[1] || "aia";
  let appidStorage = localStorage.getItem("appid");

  if (appidStorage && appid !== appidStorage) {
    localStorage.clear();
    next({ name: "home" });
    localStorage.setItem("appid", appid);
  } else {
    localStorage.setItem("appid", appid);
  }

  next();
});

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    sensors.quick("autoTrackSinglePage");
  });
});

export default router;
